// extracted by mini-css-extract-plugin
module.exports = {"eventsList":"styles__eventsList____UTi_","indicators":"styles__indicators___U3_LW"};